// @ts-nocheck
import { useCallback } from 'react'
import { acceptInvite } from 'src/redux/slices/user/endpoints'

import { Button, Grid, Typography } from '@material-ui/core'
import AcceptIcon from '@material-ui/icons/CheckCircle'

///// API Hooks

///// Types
type PendingInviteProps = {
  id: number
  org: { id: number } & { title: string }
}

///// Component
const PendingInvite: React.FC<PendingInviteProps> = ({ id, org }) => {
  const [trigger, { data, isLoading }] = acceptInvite.useMutation()

  const accept = useCallback(() => {
    trigger({ id, organization_id: org.id })
  }, [id, org.id])

  return (
    <Grid container alignItems='center' spacing={2}>
      <Grid item>
        <Typography variant='overline'>{org.title}</Typography>
      </Grid>
      <Grid item>
        <Button variant='outlined' endIcon={<AcceptIcon />} size='small' onClick={accept}>
          Accept
        </Button>
      </Grid>
    </Grid>
  )
}

export default PendingInvite
